var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoInfoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "No_information_available",
    "data-name": "No information available",
    transform: "translate(-556 -501.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1021",
    "data-name": "Rectangle 1021",
    width: 65,
    height: 64,
    transform: "translate(556 501.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "noun-not-found-3773931",
    d: "M116.56,35A11.56,11.56,0,0,0,105,46.569V79.232a11.556,11.556,0,0,0,11.56,11.561h32.663a11.563,11.563,0,0,0,11.569-11.562V46.569A11.568,11.568,0,0,0,149.222,35Zm-3.168,5.141a3.261,3.261,0,0,1,2.3.958l3.735,3.731,3.736-3.731a3.254,3.254,0,0,1,4.6,4.6l-3.735,3.735,3.735,3.729a3.256,3.256,0,0,1-4.6,4.608l-3.736-3.735-3.735,3.735a3.256,3.256,0,0,1-4.6-4.608l3.736-3.736L111.092,45.7a3.26,3.26,0,0,1,2.3-5.561Zm26.935,0a3.255,3.255,0,0,1,2.3.958l3.736,3.731L150.1,41.1a3.255,3.255,0,0,1,4.6,4.6l-3.729,3.726,3.729,3.736a3.256,3.256,0,0,1-4.6,4.608l-3.735-3.735-3.736,3.735a3.255,3.255,0,1,1-4.6-4.608l3.726-3.736L138.028,45.7a3.26,3.26,0,0,1,2.3-5.561Zm-7.509,28.673h0a16.7,16.7,0,0,1,6.606,1.3c4.12,1.758,6.816,5.123,6.816,8.895a.962.962,0,0,1-1.925,0c0-2.851-2.059-5.59-5.651-7.121a15.222,15.222,0,0,0-11.66.051c-3.565,1.562-5.577,4.321-5.532,7.17a.962.962,0,0,1-1.925.029c-.059-3.772,2.588-7.167,6.682-8.961a16.7,16.7,0,0,1,6.587-1.364Z",
    transform: "translate(455.515 470.515)",
    fill: "#e5e5e5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInfoIcon);
export default __webpack_public_path__ + "static/media/No-Info-Icon.2052b3a5ae411bccf0ae744b8ecc7c2f.svg";
export { ForwardRef as ReactComponent };